
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"50","height":"50","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('rect',{attrs:{"width":"50","height":"50","rx":"4","fill":"#E9E9E9"}}),_c('path',{attrs:{"d":"M30.038 11.41a9.714 9.714 0 00-6.32-1.324 9.873 9.873 0 00-5.787 2.948 10.51 10.51 0 00-2.848 5.994 10.677 10.677 0 001.275 6.55l7.738 13.878c.069.124.16.232.269.32a1.015 1.015 0 001.04.142c.213-.092.39-.254.506-.462l7.733-13.874a10.705 10.705 0 001.025-7.859c-.676-2.656-2.341-4.927-4.63-6.314zm2.868 8.952a8.41 8.41 0 01-1.076 4.127L25 36.744l-6.832-12.259a8.424 8.424 0 01-1.074-4.096 8.428 8.428 0 011.048-4.105 8.062 8.062 0 012.89-3.01 7.702 7.702 0 013.954-1.11c.685 0 1.367.093 2.029.274a7.895 7.895 0 014.247 2.922 8.384 8.384 0 011.644 5v.002z","fill":"#6349E9"}}),_c('path',{attrs:{"d":"M25 15.153a4.94 4.94 0 00-3.555 1.525 5.305 5.305 0 00-1.472 3.683c0 1.382.53 2.707 1.472 3.683A4.94 4.94 0 0025 25.57a4.94 4.94 0 003.555-1.526 5.305 5.305 0 001.472-3.683c0-1.38-.53-2.706-1.472-3.683A4.94 4.94 0 0025 15.153zm0 8.247a2.86 2.86 0 01-1.629-.512 3.017 3.017 0 01-1.08-1.363 3.14 3.14 0 01-.167-1.755c.114-.59.393-1.131.803-1.556.41-.425.932-.714 1.501-.831a2.838 2.838 0 011.694.172c.536.23.994.62 1.316 1.12.322.499.494 1.086.494 1.687 0 .806-.309 1.579-.859 2.148-.55.57-1.295.89-2.073.89z","fill":"#6349E9"}})])
          )
        }
      }
    